// src/pages/CreateSub.js
import { useState } from "react";
import { auth, db } from "../firebase";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";

export default function CreateSub() {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const user = auth.currentUser;
    if (!user) {
      alert("Login required");
      return;
    }
    await addDoc(collection(db, "subs"), {
      title,
      content,
      createdAt: serverTimestamp(),
      avgResistance: 0,
      totalTests: 0,

      userId: user.uid,
      username: user.displayName,
      userPhoto: user.photoURL
    });

    setTitle("");
    setContent("");
    alert("Sub created!");
  };

  return (
    <form onSubmit={handleSubmit}>
      <h3>Create Sub / Spell</h3>

      <input
        className="form-control mb-2"
        placeholder="Title"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      />

      <textarea
        className="form-control mb-2"
        placeholder="Write your subliminal / mantra"
        value={content}
        onChange={(e) => setContent(e.target.value)}
      />

      <button className="btn btn-primary">Post</button>
    </form>
  );
}